import { render, staticRenderFns } from "./WinnerItem.vue?vue&type=template&id=d2df8f54&functional=true&"
import script from "./WinnerItem.vue?vue&type=script&lang=js&"
export * from "./WinnerItem.vue?vue&type=script&lang=js&"
import style0 from "./WinnerItem.vue?vue&type=style&index=0&id=d2df8f54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports